import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class CurrencyUpdateApiHF extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/sap/update-currency',
      requesterInfo,
    })
  }

  public async updateCurrency(): Promise<any> {
    return await this.postAsync<any>()
  }
}
